// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) { return "js/" + chunkId + "-legacy." + {"79":"010783d4","90":"ea993362","624":"6b6eb718","978":"7218cbdb"}[chunkId] + ".js"; };